import { render } from "./TicketsWidget.vue?vue&type=template&id=2fca625b"
import script from "./TicketsWidget.vue?vue&type=script&lang=js"
export * from "./TicketsWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__